import { action, computed, makeObservable, observable } from 'mobx';
import { AgenturStore } from '../agentur.store';
import { AgtGoogleProfileUiStore, GoogleProfileVM } from './agt.googleprofile.ui.store';
import { AgenturModel } from 'app/models/agentur.model';
import { AgtAkumaPrimeKwVM, AgtAkumaPrimeUiStore } from './agt.akumaprime.ui.store';
import { AgtAkumaPlanerUiStore, AgtAkumaPlanerVM } from './agt.akumaplaner.ui.store';
import { AgtDigitalreportUiStore, DigitalReportVM } from './agt.digitalreport.ui.store';
import { BaseUiStore } from './base.ui.store';
import { AgtAmisNowUiStore, AmisNowVm } from './agt.amisnow.ui.store';
import { AgtSocialMediaUiStore, AgtSocialMediaVM } from './agt.socialmedia.ui.store';
import { AgtLeadNowUiStore, LeadNowVM } from './agt.leadnow.ui.store';
import { AgtKvmUiStore, KvmVM } from './agt.kvm.ui.store';
import { AgtStsUiStore, StsVM } from './agt.sts.ui.store';
import { max } from 'lodash';
import { AgtAkumaAktionenUiStore, AkumaAktionenVM } from './agt.akumaaktionen.ui.store';
import _ from 'lodash';

interface IFitModel {
	ziel?: number;
	ergebnis?: number;
	max?: number;
}

export class FitModel {
	constructor(opts: IFitModel) {
		makeObservable(this);
		this.ergebnis = opts.ergebnis;
		this.ziel = opts.ziel;
		this.max = opts.max;
	}

	ergebnis?: number;
	ziel?: number;
	max?: number;

	@computed
	get ze() {
		if (!this.ziel || !this.ergebnis || this.ziel === 0) {
			return 0;
		}
		const z = this.ziel;
		const e = this.ergebnis;
		if (e > z) return 100;
		let ze = (e / z) * 100;
		ze = Math.round(ze * 100) / 100;
		return ze;
	}
}

export class AgtFitnessVm {
	agt: AgenturModel;
	gup?: GoogleProfileVM;
	prime?: AgtAkumaPrimeKwVM;
	planer?: AgtAkumaPlanerVM;
	digiReport?: DigitalReportVM;
	amisNow?: AmisNowVm;
	isPrime?: boolean;
	maxPrimeKw: number = 0;
	sm?: AgtSocialMediaVM;
	leadNow?: LeadNowVM;
	maxLeadnowKw: number = 0;
	kvm?: KvmVM;
	bk?: StsVM;
	aktion?: AkumaAktionenVM;

	keineDaten: boolean = false;

	constructor(
		agt: AgenturModel,
		gup?: GoogleProfileVM,
		prime?: AgtAkumaPrimeKwVM,
		planer?: AgtAkumaPlanerVM,
		aktion?: AkumaAktionenVM,
		digiReport?: DigitalReportVM,
		ami?: AmisNowVm,
		isPrime?: boolean,
		maxPrimeKw?: number,
		sm?: AgtSocialMediaVM,
		leadNow?: LeadNowVM,
		maxLeadnowKw?: number,
		kvm?: KvmVM,
		bk?: StsVM,
	) {
		this.agt = agt;
		this.gup = gup;
		this.prime = prime;
		this.planer = planer;
		this.digiReport = digiReport;
		this.amisNow = ami;
		this.isPrime = isPrime;
		this.maxPrimeKw = maxPrimeKw ? maxPrimeKw : 0;
		this.sm = sm;
		this.leadNow = leadNow;
		this.maxLeadnowKw = maxLeadnowKw ? maxLeadnowKw : 0;
		this.kvm = kvm;
		this.bk = bk;
		this.aktion = aktion;

		if (!agt && !gup && !prime && !planer && !digiReport && !ami && !isPrime && !sm && !leadNow && !kvm && !bk) {
			this.keineDaten = true;
		}
	}

	@computed
	get googleExists() {
		return !!this.gup ? 1 : 0;
	}

	@computed
	get primeExists() {
		return !!this.prime ? 1 : 0;
	}

	@computed
	get planerExists() {
		return !!this.planer ? 1 : 0;
	}

	@computed
	get mazExists() {
		if (this.digiReport && this.mazBestandDurchdringungsquote && this.mazBestandDurchdringungsquote.ziel! >= 0) {
			return 1;
		}
		return 0;
	}

	@computed
	get amisNowExists() {
		return !!this.amisNow && !!this.amisNow.aggregated ? 1 : 0;
	}

	//// GOOGLE ///////
	// @computed
	// get gupAverage() {
	// 	if (!this.gup) {
	// 		return new FitModel({});
	// 	}
	// 	// const vals = [this.anzBew.ze, this.bewAvg.ze, this.imgCount.ze, this.qCount.ze];
	// 	// const res = vals.reduce((acc, val) => acc + val, 0) / vals.length;
	// 	const res = 4321;

	// 	return new FitModel({
	// 		ziel: 100,
	// 		ergebnis: res,
	// 	});
	// }

	@computed
	get neueBewertung() {
		if (!this.gup) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: 3,
			ergebnis: this.gup.neueBewertung,
		});
	}

	@computed
	get anzBew() {
		if (!this.gup) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: 25,
			ergebnis: this.gup.bew,
		});
	}

	@computed
	get gupBewAvg() {
		if (!this.gup) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: 4.5,
			ergebnis: this.gup.bewAvg,
		});
	}

	@computed
	get imgCount() {
		if (!this.gup) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: 5,
			ergebnis: this.gup.imgCount,
		});
	}

	// @computed
	// get qCount() {
	// 	if (!this.gup) {
	// 		return new FitModel({});
	// 	}
	// 	return new FitModel({
	// 		ziel: 5,
	// 		ergebnis: this.gup.qCount,
	// 	});
	// }

	//// AMIS.NOW  ///////
	@computed
	get amisNowQuoteRead() {
		if (!this.amisNow || !this.amisNow.aggregated) {
			return new FitModel({});
		}

		return new FitModel({
			ziel: this.amisNow.aggregated.summe,
			ergebnis: this.amisNow.aggregated.davonRead,
		});
	}

	//// AKUMA  ///////
	@computed
	get isAkumaPrimeUser() {
		if (this.prime && this.prime.einordnungsQuote > 0) {
			return 1;
		}
		return 0;
	}

	@computed
	get planerAnzahlWochenNutzung() {
		if (!this.planer) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: this.planer.wochen,
			ergebnis: this.planer.gpWochen,
		});
	}

	@computed
	get planerUebertragungquoteAmisNow() {
		// ?AmisNow?
		if (!this.planer) {
			return new FitModel({});
		}
		return new FitModel({
			// ziel: 40,
			// ergebnis: this.planer.uebertragungsQuote,
			ziel: this.planer.gesamt,
			ergebnis: this.planer.zu,
		});
	}

	@computed
	get primeEinordnungsquote() {
		if (!this.prime) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: this.prime.einordnungTotal,
			ergebnis: this.prime.eingeordnetTotal,
		});
	}
	@computed
	get primeKundenKontaktQuote() {
		if (!this.prime) {
			return new FitModel({});
		}
		return new FitModel({
			//ziel: this.prime.einordnungTotal,
			ziel: 100,
			ergebnis: this.prime.kundenkontaktquote,
		});
	}

	@computed
	get primeAbwahlquote() {
		if (!this.prime) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: this.prime.eingeordnetTotal,
			ergebnis: this.prime.abwahl,
		});
	}

	@computed
	get primeTerminierungExtern() {
		if (!this.prime) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: this.prime.zuKontaktierendeKunden,
			ergebnis: this.prime.terminierungExternTotal,
		});
	}

	// akuma aktionen - Aktionsbearbeitung
	@computed
	get aktionenAnzahlTopAktionen() {
		if (this.aktion && this.aktion.overviewItem) {
			return _.get(this.aktion.overviewItem, 'topCustumerCount', 0);
		}
		return 0;
	}

	@computed
	get aktionenAnzahlTopAktionenBearbeitet() {
		if (this.aktion && this.aktion.overviewItem) {
			return _.get(this.aktion.overviewItem, 'topAgencyCount', 0);
		}
		return 0;
	}

	@computed
	get aktionenAnzahlTopAktionenQuote() {
		if (this.aktion && this.aktion.overviewItem) {
			return _.get(this.aktion.overviewItem, 'topQuote', 0);
		}
		return 0;
	}

	@computed
	get aktionenAnzahlTopAufgaben() {
		if (this.aktion && this.aktion.overviewItem) {
			return _.get(this.aktion.overviewItem, 'topTasks', 0);
		}
		return 0;
	}

	/// Meine Allianz
	@computed
	get mazBestandDurchdringungsquote() {
		if (!this.digiReport) {
			return new FitModel({ ziel: -1 });
		}

		const anz = this.digiReport.pos.anzKunden18;
		const erg = this.digiReport.pos.anzMaz18;

		// erg = Math.round(erg);
		return new FitModel({
			ziel: anz,
			ergebnis: erg,
			max: Math.floor(anz * 0.6),
		});
	}

	@computed
	get mazNeuDurchdringungsquote() {
		if (!this.digiReport) {
			return new FitModel({});
		}
		const anz = this.digiReport.pos.anzKundenNeu;
		const erg = this.digiReport.pos.anzMazNeu;

		return new FitModel({
			ziel: anz,
			ergebnis: erg,
		});
	}

	// multisgp - GUP
	@computed
	get gupGpCount() {
		if (this.anzBew.ergebnis && this.anzBew.ergebnis >= 25) {
			return this.agt.thCount ? this.agt.thCount : 1;
		}
		return 0;
	}

	// multisgp - Akuma
	@computed
	get isCurrentAkumaPrimeUser() {
		if (this.prime) {
			// this.prime
			return this.prime.maxKw >= this.maxPrimeKw ? 1 : 0;
		}
		return 0;
	}

	@computed
	get gpWochenCurrYear() {
		// current year needs to be set by the loader.
		return this.planer?.kwsAbove50Count || 0;
	}

	@computed
	get has12WeeksOfPlanerInCurrentYear() {
		return this.gpWochenCurrYear >= 12 ? 1 : 0;
	}

	@computed
	get akumaMultiGpCount() {
		if (this.isCurrentAkumaPrimeUser || this.has12WeeksOfPlanerInCurrentYear) {
			return this.agt.thCount ? this.agt.thCount : 1;
		}
		return 0;
	}

	@computed
	get isCurrentAkumaPrimeUserGpCount() {
		if (this.isCurrentAkumaPrimeUser) {
			return this.agt.thCount ? this.agt.thCount : 1;
		}
		return 0;
	}
	@computed
	get akumaPlanerGpCount() {
		if (this.has12WeeksOfPlanerInCurrentYear) {
			// planer zählt wenn nicht gleichzeitig prime aktiv ist
			if (this.isCurrentAkumaPrimeUser) {
				return 0;
			}
			return this.agt.thCount ? this.agt.thCount : 1;
		}
		return 0;
	}
	@computed
	get akumaPlanerGpCountDebug() {
		if (this.has12WeeksOfPlanerInCurrentYear) {
			return this.agt.thCount ? this.agt.thCount : 1;
		}
		return 0;
	}

	// multisgp - LeadNow
	@computed
	get isCurrentLeadNowUser() {
		return this.leadNow && this.leadNow.isCurrentLeadNowUser === 1 ? 1 : 0;
	}

	// @computed
	// get isCurrentLeadNowUserMultiGp() {
	// 	return this.leadNow && this.leadNow.isCurrentLeadNowUserMultiGp === 1 ? 1 : 0;
	// }

	@computed
	get leadnowMultiGpCount() {
		if (this.leadNow && this.leadNow.isConsecutive12 === 1) {
			return this.agt.thCount ? this.agt.thCount : 1;
		}
		return 0;
	}

	@computed
	get leadnowMultiGpAgtOnlyCount() {
		if (this.isCurrentLeadNowUser) {
			return 1;
		}
		return 0;
	}

	/// Facebook
	@computed
	get fbStatus() {
		return this.sm?.currFb?.status || 0;
	}
	@computed
	get fbFanAnzahl() {
		if (this.sm && this.sm.currFb) {
			return new FitModel({
				ziel: 250,
				ergebnis: this.sm.currFb.fans,
			});
		}
		return new FitModel({});
	}
	@computed
	get fbPostinganzahl() {
		if (this.sm && this.sm.currFb) {
			return new FitModel({
				ergebnis: this.sm.fbPostsYtd,
			});
		}
		return new FitModel({});
	}
	@computed
	get fbEigenePosts() {
		if (this.sm && this.sm.currFb) {
			return new FitModel({
				ergebnis: this.sm.currFb?.ownPosts,
				ziel: 4,
			});
		}
		return new FitModel({});
	}
	@computed
	get fbPRAbo() {
		return this.sm?.currFb?.aboPr || 0;
	}
	@computed
	get fb1890Abo() {
		return this.sm?.currFb?.abo1890 || 0;
	}

	// Instagram
	@computed
	get instaStatus() {
		return this.sm?.currInsta?.status || 0;
	}
	@computed
	get instaFollower() {
		if (this.sm && this.sm.currInsta) {
			return new FitModel({
				ziel: 250,
				ergebnis: this.sm.currInsta.follow,
			});
		}
		return new FitModel({});
	}
	@computed
	get instaPostinganzahl() {
		if (this.sm && this.sm.currInsta) {
			return new FitModel({
				ergebnis: this.sm.instaPostsYtd,
			});
		}
		new FitModel({});
	}
	@computed
	get instaEigenePosts() {
		if (this.sm && this.sm.currInsta) {
			return new FitModel({
				ergebnis: this.sm.currInsta?.ownPosts,
				ziel: 4,
			});
		}
		return new FitModel({});
	}
	@computed
	get instaPRAbo() {
		return this.sm?.currInsta?.aboPr || 0;
	}

	// titkok
	@computed
	get tikTokPosts() {
		if (this.sm && this.sm.currTiktok) {
			return new FitModel({
				ergebnis: this.sm.currTiktok.posts,
				ziel: 4,
			});
		}
		return new FitModel({});
	}

	// linked
	@computed
	get linkedInPosts() {
		if (this.sm && this.sm.currLinkedin) {
			return new FitModel({
				ergebnis: this.sm.currLinkedin.posts,
				ziel: 4,
			});
		}
		return new FitModel({});
	}

	// LeadNow
	@computed
	get leadNowBrutto() {
		if (!this.leadNow) return null;
		return this.leadNow.brutto;
	}
	@computed
	get leadNowNetto() {
		if (!this.leadNow) return null;
		return this.leadNow.netto;
	}
	@computed
	get leadNowStorno() {
		if (!this.leadNow) return null;
		return this.leadNow.storno;
	}
	@computed
	get leadNowAv() {
		if (!this.leadNow) return null;
		return this.leadNow.av?.brutto;
	}
	@computed
	get leadNowBaufi() {
		if (!this.leadNow) return null;
		return this.leadNow.baufi?.brutto;
	}
	@computed
	get leadNowBausp() {
		if (!this.leadNow) return null;
		return this.leadNow.bausp?.brutto;
	}
	@computed
	get leadNowBu() {
		if (!this.leadNow) return null;
		return this.leadNow.bu?.brutto;
	}
	@computed
	get leadNowFsach() {
		if (!this.leadNow) return null;
		return this.leadNow.fsach?.brutto;
	}
	@computed
	get leadNowKfz() {
		if (!this.leadNow) return null;
		return this.leadNow.kfz?.brutto;
	}
	@computed
	get leadNowKv() {
		if (!this.leadNow) return null;
		return this.leadNow.kv?.brutto;
	}
	@computed
	get leadNowKzus() {
		if (!this.leadNow) return null;
		return this.leadNow.kzus?.brutto;
	}
	@computed
	get leadNowPsach() {
		if (!this.leadNow) return null;
		return this.leadNow.psach?.brutto;
	}
	@computed
	get leadNowReise() {
		if (!this.leadNow) return null;
		return this.leadNow.reise?.brutto;
	}
	@computed
	get leadNowTier() {
		if (!this.leadNow) return null;
		return this.leadNow.tier?.brutto;
	}
	@computed
	get leadNowBerat() {
		if (!this.leadNow) return null;
		return this.leadNow.berat?.brutto;
	}
	@computed
	get leadNowQuote() {
		if (!this.leadNow) {
			return new FitModel({ ziel: -1 });
		}

		const anz = this.leadNow.netto;
		const erg = this.leadNow.brutto;

		// erg = Math.round(erg);
		return new FitModel({
			ziel: anz,
			ergebnis: erg,
		});
	}

	// KVM
	@computed
	get anzahlAnrufeGesamtYtd() {
		if (!this.kvm) return new FitModel({});
		return new FitModel({
			ergebnis: this.kvm.anzahlAnrufeGesamtYtd,
		});
	}
	@computed
	get kvmMonthly() {
		if (!this.kvm) return null;
		return this.kvm.items;
	}
	@computed
	get kvmMonthlyAverage() {
		if (!this.kvm) return null;
		return (this.kvm.vuInbound || 0) / this.kvm.anzahlBm;
	}

	@computed
	get kvmVuInbound3MonthAverage() {
		if (!this.kvm) return null;
		const items = this.kvm.items;
		if (!items || items.length === 0) return null;
		const last3 = items.slice(-3);
		const sum = last3.reduce((acc, item) => acc + (item.vuInbound || 0), 0);
		return sum / last3.length;
	}

	// STS - Bürokräfte
	@computed
	get stsData() {
		if (!this.bk) return null;
		return this.bk.sts4Adz;
	}

	@computed
	get stsBasicSchulung() {
		if (!this.bk) return null;
		return this.bk.basicSchulung;
	}

	// FitModel values for graphics
	@computed
	get stsBasicSchulungAverageFit() {
		if (!this.bk) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: 100,
			ergebnis: this.bk.basicSchulung,
		});
	}

	@computed
	get stsMcSchulungAverageFit() {
		if (!this.bk) {
			return new FitModel({});
		}
		return new FitModel({
			ziel: 100,
			ergebnis: this.bk.mcSchulung,
		});
	}
}

export class AgtFitnessUiStore extends BaseUiStore<AgtFitnessVm> {
	name = 'AgtFitnessUiStore';
	agenturStore: AgenturStore;
	agtDigitalreportUiStore: AgtDigitalreportUiStore;
	agtAkumaPlanerUiStore: AgtAkumaPlanerUiStore;
	agtAkumaPrimeUiStore: AgtAkumaPrimeUiStore;
	agtGoolgeProfileUiStore: AgtGoogleProfileUiStore;
	agtAmisNowUiStore: AgtAmisNowUiStore;
	agtSocialMediaUiStore: AgtSocialMediaUiStore;
	agtLeadNowUiStore: AgtLeadNowUiStore;
	kvmUiStore: AgtKvmUiStore;
	agtStsUiStore: AgtStsUiStore;
	agtAkumaAktionenUiStore: AgtAkumaAktionenUiStore;

	constructor(
		agenturStore: AgenturStore,
		agtGoolgeProfileUiStore: AgtGoogleProfileUiStore,
		agtAkumaPrimeUiStore: AgtAkumaPrimeUiStore,
		agtAkumaPlanerUiStore: AgtAkumaPlanerUiStore,
		agtDigitalreportUiStore: AgtDigitalreportUiStore,
		agtAmisNowUiStore: AgtAmisNowUiStore,
		agtSocialMediaUiStore: AgtSocialMediaUiStore,
		agtLeadNowUiStore: AgtLeadNowUiStore,
		kvmUiStore: AgtKvmUiStore,
		agtStsUiStore: AgtStsUiStore,
		agtAkumaAktionenUiStore: AgtAkumaAktionenUiStore,
	) {
		super();
		this.agenturStore = agenturStore;
		this.agtDigitalreportUiStore = agtDigitalreportUiStore;
		this.agtAkumaPlanerUiStore = agtAkumaPlanerUiStore;
		this.agtAkumaPrimeUiStore = agtAkumaPrimeUiStore;
		this.agtGoolgeProfileUiStore = agtGoolgeProfileUiStore;
		this.agtAmisNowUiStore = agtAmisNowUiStore;
		this.agtSocialMediaUiStore = agtSocialMediaUiStore;
		this.agtLeadNowUiStore = agtLeadNowUiStore;
		this.kvmUiStore = kvmUiStore;
		this.agtStsUiStore = agtStsUiStore;
		this.agtAkumaAktionenUiStore = agtAkumaAktionenUiStore;
	}

	planerMinDate = 202501; // KW 1/2025

	// First KW/BM of the fitness tracker year (the value works for both formats).
	// Used for the aggregation calls and as the scope start in entityScopes.
	fitnessStart = 202601;

	@computed
	get entityScopes() {
		const scopes: any = {};
		// Starts come from fitnessStart and ends from data-driven getters — never from
		// the other stores' min/max Kw/BmCurrent fields, which belong to the report pickers.
		scopes.gup = {
			scope: 'bm -> maxBm -> moment',
			start: this.fitnessStart,
			end: _.max(this.agtGoolgeProfileUiStore.bms),
			format: 'bm',
		};
		scopes.akumaPrime = {
			scope: 'sum of kw -> ytd',
			start: this.fitnessStart,
			end: this.agtAkumaPrimeUiStore.lastWeek,
			format: 'kw',
		};
		scopes.akumaPlaner = {
			scope: 'sum of kw -> ytd',
			start: this.planerMinDate,
			end: this.agtAkumaPlanerUiStore.lastWeek,
			format: 'kw',
		};
		scopes.maz = {
			scope: 'bm -> maxBm -> moment',
			start: this.agtDigitalreportUiStore.maxBm,
			end: this.agtDigitalreportUiStore.maxBm,
		};
		scopes.amisNow = {
			scope: 'year to date (bm)',
			start: this.fitnessStart,
			end: this.agtAmisNowUiStore.maxBm,
			format: 'bm',
		};

		scopes.socialMedia = {
			scope: 'bm -> maxBm -> moment',
			start: this.fitnessStart,
			end: _.max(this.agtSocialMediaUiStore.bms),
			format: 'bm',
		};

		scopes.leadNow = {
			scope: 'sum of kw -> ytd',
			start: this.fitnessStart,
			end: this.agtLeadNowUiStore.lastKw,
			format: 'kw',
		};

		scopes.kvm = {
			scope: 'sum of bm -> ytd',
			start: this.kvmUiStore.minBmCurrent,
			end: this.kvmUiStore.maxBmCurrent,
			format: 'bm',
		};

		scopes.sts = {
			scope: 'moment',
			start: this.agtStsUiStore.datenStand,
			end: this.agtStsUiStore.datenStand,
		};
		return scopes;
	}
	@action
	async _baseLoad() {
		const promises1 = await Promise.all([
			this.agenturStore.findAll(),
			this.agtAkumaPlanerUiStore.load(), // ensure that akuma planer kws are loaded (needed for max date)
			this.agtAkumaPrimeUiStore.load(), // ensure that akuma planer kws are loaded (needed for max date)
			this.agtAkumaAktionenUiStore.load(),
			this.agtDigitalreportUiStore.load(), // ensure that bms are loaded
			this.agtGoolgeProfileUiStore.load(), // ensure that bms are loaded
			this.kvmUiStore.load(), // ensure that bms are loaded
			this.agtLeadNowUiStore.load(),
			this.agtAmisNowUiStore.load(),
		]);

		const year = 2026;
		const startDate = this.fitnessStart;
		const maxKw = 202654;
		const maxBm = 202612;

		// Keep a handle on the leadnow result: the aggregation covers the whole fitness
		// range, while currentKWItems is filtered by the picker-backed min/maxKwCurrent
		// (defaulting to the latest KW only) and must not be used here.
		const leadnowPromise = this.agtLeadNowUiStore.aggregateAgtsByBm(startDate, this.agtLeadNowUiStore.maxKw!);
		await Promise.all([
			this.agtAkumaPlanerUiStore.aggreagateAgtsByKw(startDate, maxKw),
			this.agtAkumaPrimeUiStore.aggreagateAgtsByKw(startDate, maxKw),
			this.agtAkumaAktionenUiStore.loadCampaignCountOverviewByBm(this.agtAkumaAktionenUiStore.maxKw),
			this.agtDigitalreportUiStore.loadByBm(this.agtDigitalreportUiStore.maxBm!),
			this.agtGoolgeProfileUiStore.loadByBmWithChanges(this.agtGoolgeProfileUiStore.maxBm!),
			this.agtAmisNowUiStore.aggreagateAgtsByBm(startDate, this.agtAmisNowUiStore.maxBm),
			leadnowPromise,
			this.kvmUiStore.aggregateAgtsByBm(startDate, maxBm),
			this.agtSocialMediaUiStore.loadByMaxBmForYear(year),
			this.agtStsUiStore.load(),
		]);
		const leadnowItems = await leadnowPromise;

		const kvmMonthly = await this.kvmUiStore.loadLast3Months();
		// const promises = await Promise.all([this.agenturStore.findAll(), this.agtGoolgeProfileUiStore.load(), this.agtDigitalreportUiStore.findAll()]);

		// agtGoolgeProfileUiStore - To date
		// agtAkumaPrimeUiStore - KW
		// agtAkumaPlanerUiStore - KW
		// agtDigitalreportUiStore - Current
		// agtAmisNowUiStore - Annual

		// agtSocialMediaUiStore - BM
		// agtLeadNowUiStore - KW
		// kvmUiStore - BM
		// agtStsUiStore - Lifetime

		// Do NOT write min/maxKwCurrent / min/maxBmCurrent of other ui stores here:
		// those fields back the report pickers, so overriding them leaks the fitness
		// range into the reports. entityScopes reads fitnessStart and data-driven end
		// getters instead, and the aggregation calls above pass their range explicitly.

		// Create Maps for O(1) lookup instead of O(n) findAndSplice
		const primesByAgtId = new Map(this.agtAkumaPrimeUiStore.currentKWItems.map((a) => [a.agt.agtId, a]));
		const plansByAgtId = new Map(this.agtAkumaPlanerUiStore.currentKWItems.map((a) => [a.agt.agtId, a]));
		const aktionByAgtId = new Map(this.agtAkumaAktionenUiStore.items.map((a) => [a.agt.agtId, a]));
		const leadsByAgtId = new Map(leadnowItems.map((a) => [a.agt.agtId, a]));
		const smsByAgtId = new Map(this.agtSocialMediaUiStore.items.map((a) => [a.agt.agtId, a]));
		const kvmsByAgtId = new Map(this.kvmUiStore.currentBmItems.map((a) => [a.agt.agtId, a]));
		const gupsByAgtId = new Map(this.agtGoolgeProfileUiStore.items.map((a) => [a.agt.agtId, a]));
		const amisByAgtId = new Map(this.agtAmisNowUiStore.items.map((a) => [a.agt.agtId, a]));
		const digisByAgtId = new Map(this.agtDigitalreportUiStore.items.map((a) => [a.agt.agtId, a]));
		const stsByAgtId = new Map(this.agtStsUiStore.items.map((a) => [a.agt.agtId, a]));
		const res: AgtFitnessVm[] = [];
		const agts = promises1[0];
		let i = 0;
		const maxPrimeKw = this.agtAkumaPrimeUiStore.maxKw;
		const maxLeadnowKw = this.agtLeadNowUiStore.maxKw;
		for (const agt of agts) {
			if (agt.gpShort === 'AGP' || !agt.vdId || !agt.gsId || agt.gsId === 'XX') {
				continue;
			}

			const isPrime = this.agtAkumaPrimeUiStore.checkAgtParticipation(agt.agtId);

			// Direct Map lookups instead of findAndSplice
			const gup = gupsByAgtId.get(agt.agtId);
			const prime = primesByAgtId.get(agt.agtId);
			const planer = plansByAgtId.get(agt.agtId);
			const aktion = aktionByAgtId.get(agt.agtId);
			const digi = digisByAgtId.get(agt.agtId);
			const ami = amisByAgtId.get(agt.agtId);
			const sm = smsByAgtId.get(agt.agtId);
			const lead = leadsByAgtId.get(agt.agtId);
			const kvm = kvmsByAgtId.get(agt.agtId);
			const kvmM = kvmMonthly.filter((k) => k.agtId === agt.agtId);
			if (kvm && kvmM) {
				kvm.items = kvmM;
			}
			const sts = stsByAgtId.get(agt.agtId);
			// if (sts && sts.sts.length > 1) {
			// 	debugger;
			// }

			const vm = new AgtFitnessVm(agt, gup, prime, planer, aktion, digi, ami, isPrime, maxPrimeKw, sm, lead, maxLeadnowKw, kvm, sts);
			if (vm.keineDaten) {
				i++;
				continue;
			}

			res.push(vm);
		}

		console.warn('FITNESSTRACKER: ', i, ' Agenturen haben keine Daten und werden nicht angezeigt.');

		this.items = res;
	}
}

export class AgtFitnessMultiGpUiStore extends AgtFitnessUiStore {
	planerMinDate = 202401;
}
